@if (showSpinner) {
  <app-loader> </app-loader>
}
<main class="content-wrapper" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  @if (isavailablefeature('isView')) {
    <div class="container-fluid mb-4">
      <div class="salary-input pb-3" [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
        <form #f="ngForm" (ngSubmit)="onSubmit(f)">
          @if (isavailablefeature('isMothySalary')) {
            <div class="heading-main py-2">
              <h1 class="">Monthly Salary</h1>
            </div>
          }
          <div class="row button-row ml-1 mr-1 justify-content-between text-left"
            [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            <div class="col-sm-5 p-0">
              @if (isavailablefeature('isMothySalary')) {
                <div class="d-flex justify-content-between">
                  <div class="col-sm-6 mt-3 mt-sm-0">
                    <input type="text" onfocus="(this.type='date')" placeholder="Select Month" name="salary_month"
                      id="salary_month" class="date-type form-control inputbtn" ngModel #enddate="ngModel">
                    </div>
                    <div class="col-sm-6 mt-3 mt-sm-0  ">
                <button (click)="monthlySalary()" type="submit " class="btn btn-primary
                apply show-salary">
                        Show Monthly Salary
                      </button>
                    </div>
                  </div>
                }
              </div>
              <!-- ........... -->
              <div class="col-sm-4 mt-3 mt-sm-0 d-flex p-0 justify-content-between text-right">
                <!-- new user add for start HR -->
                <div class="col-6">
                  @if (isavailablefeature('isloanReport')) {
                    <button (click)="loanReport()"
                      class="btn text-white font-weight-bold report-btn d-flex">
                      @if (loannotification.total_count != 0) {
                        <span class="req-notify"> {{loannotification.total_count}}
                        </span>
                        } Loan Report
                      </button>
                    }
                  </div>
                  <div class="col-6">
                    @if (isavailablefeature('isAddUser')) {
                      <button (click)="addNewUserBtn()"
                        class="btn text-white font-weight-bold apply add-btn">
                        + Create New User
                      </button>
                    }
                  </div>
                </div>
                <!-- end HR -->
              </div>
            </form>
          </div>
          <!-- tabs buttons -->
          <div class="col-12 main-div">
            <div class="parentCurrentYear col-6 pl-1">
              <button type="button" class="col-4" (click)="showCurrentEmployee()"
                [ngClass]="{'btnCurrentemployee': isCurrentEmployee, 'btnoldEmployee': isoldEmployee}">Current
              Employees</button>
              @if (isavailablefeature('isTeamlead')) {
                <button type="button" class="col-4" (click)="showoldEmployee()"
                [ngClass]="{'btnCurrentemployee': isoldEmployee, 'btnoldEmployee': isCurrentEmployee}">Ex Employees</button>
              }
            </div>
          </div>
          @if (isCurrentEmployee) {
            <div class=" mt-0">
              @for (department of departmentNames; track department) {
                <div class="businessteam-section mt-4">
                  <div class="heading-main py-2" [ngClass]="{ 'dark-text': selectedMode === 'dark' }">
                    <h1 class="">{{ department}}</h1>
                  </div>
                  <div class="employee-grid management-row">
                    @for (user of usersList[department]; track user; let i = $index) {
                      <div class="employee-card teamlead-card my-2"
                        [style.background-image]="user.backgroundImage ? 'url(' + user.backgroundImage + ')' : ''">
                        <div class="div">
                          <div class="image-titles d-flex justify-content-between">
                            <div class="employee-year">
                              @if ( userRolesArray[departmentNames.indexOf(department)][i] === 'Admin' ||  userRolesArray[departmentNames.indexOf(department)][i] === 'Admin_AND_Team_Lead') {
                                <img src="./assets/images/admin.png" alt=""
                                  >
                              }
                            </div>
                            <div class="employee-year">
                              @if (userRolesArray[departmentNames.indexOf(department)][i] === 'Team_Lead' || userRolesArray[departmentNames.indexOf(department)][i] === 'Admin_AND_Team_Lead') {
                                <img src="./assets/images/team lead.png" alt=""
                                  >
                              }
                            </div>
                          </div>
                          <div class="employee-profile text-center" (click)="showDetails(user)">
                            <div class="profile-image">
                              <img src="{{user.profile_image }}" alt="image">
                            </div>
                            <h1 class="mt-2 mb-1">{{user.first_name}} {{user.last_name}}</h1>
                            <h2>{{user.description}}</h2>
                            <!-- <h2>{{ userRolesArray[departmentNames.indexOf(department)][i] }}</h2> -->
                          </div>
                          <div class="employee-info mt-2">
                            <p><img src="../../../assets/images/mail.png" alt=""> {{user.email}}</p>
                            <p>
                              <img class="mb-1" src="../../../assets/images/clock.png" alt="">
                              {{ convertTo12Hour(user.usershittime[0].start_time || user.shift_start_time) }}
                              to
                              {{ convertTo12Hour(user.usershittime[0].end_time || user.shift_end_time) }}
                            </p>
                            <div class="employee-eva">
                              @if (user.employee_evaluation.point == null || user.employee_evaluation.point !== '') {
                                <h1 class="pr-2"
                                  >
                                  {{ user.employee_evaluation.points | number: '1.1-1' }}
                                </h1>
                              }
                              @if (user.employee_evaluation.point === null || user.employee_evaluation.point === '') {
                                <h1 class="pr-2"
                                >0.0</h1>
                              }
                              <p><span>EVALUATION</span><span>OUT</span><span>OF 10</span></p>
                            </div>
                            @if (isavailablefeature('isWFH')) {
                              <div class="employee-info-footer">
                                <h3>Allow WFH for Today:</h3>
                                @if (user.tracker == 1) {
                                  <div>
                                    <img src="assets/attendance/activity.svg" alt="Missing image" class="activity-tracker">
                                  </div>
                                }
                                <!-- <input [checked]="isWFHAllowed(user)" type="checkbox" (click)="toggleClick(user, $event)"> -->
                                <input type="checkbox" #toggleRef [checked]="isWFHAllowed(user)"
                                  (change)="toggleClick(user, $event, toggleRef)">
                                </div>
                              }
                            </div>
                          </div>
                          <div class="col-12 d-flex justify-content-between mt-3 mb-3 flex-wrap">
                            @if (isavailablefeature('isDeleteUser')) {
                              <button (click)="deleteModal(user)"
                                class="delete-btn text-center btn btn-light " type="submit" data-toggle="modal"
                                data-target="#deleteModal">
                                <div><i class="fa fa-trash-o"></i></div>
                              </button>
                            }
                            @if (isavailablefeature('isUpdateUser')) {
                              <div class="edit-btn text-center float-right btn btn-light"
                                data-toggle="modal" data-target="#quickEditModal" (click)="setUserUUID(user.uuid)">
                                <div><i class="fa fa-edit"></i></div>
                              </div>
                            }
                          </div>
                          <!-- <div class="employee-card-footer text-center py-2">
                          <a (click)="childClick($event)" *ngFor="let footerImage of getFooterImages(department)">
                            <img [src]="'../../../assets/images/' + footerImage" alt="">
                          </a>
                        </div> -->
                        <!-- bottom-border  -->
                        <div class="yellow-label">
                        </div>
                        <div class="yellow-label-left">
                        </div>
                        <div class="yellow-label-right">
                        </div>
                      </div>
                    }
                  </div>
                  <!-- <div class="pagination">
                  <button (click)="onPageChange(department, currentPage[department] - 1)" [disabled]="currentPage[department] === 1">
                    &laquo; Previous
                  </button>
                  <span *ngFor="let page of [].constructor(totalPages[department]); let i = index">
                    <button (click)="onPageChange(department, i + 1)" [class.active]="i + 1 === currentPage[department]">
                      {{ i + 1 }}
                    </button>
                  </span>
                  <button (click)="onPageChange(department, currentPage[department] + 1)" [disabled]="currentPage[department] === totalPages[department]">
                    Next &raquo;
                  </button>
                </div> -->
              </div>
            }
            <!-- WFH modal -->
            <div class="modal fade " id="confirmModalss" tabindex="-1" role="dialog" aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered " role="document">
                <div class="modal-content custom-modal " [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
                  <div class="modal-header text-white"
                    style="padding-right: 20px; display: flex; align-items: center; border-bottom: none;">
                    <button type="button" data-bs-dismiss="modal" class="close">×</button>
                  </div>
                  @if (toggleUserStatus== 1) {
                    <div class="modal-body text-center" [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }"
                      >
                      <button type="button" class="btn-close float-end" data-bs-dismiss="modal" aria-label="Close"></button>
                      <img src="../../../assets/images/trackerConfirm.png" class="imageConfirmModal" alt="img loading...">
                      <p class="modal-text mt-3 ">
                        Are you sure you want to <span class="textColorQuestionMOdal">Allow <span class="textColorMOdal">{{
                      userNameForModal }}</span></span>
                      to
                      <span class="textColorMOdal">work from home</span>?
                    </p>
                    <div class="buttonTrackers gap-3 mt-3 mb-3">
                      <button type="button" class="subBtnModalTrackerOff custom-btn" data-bs-dismiss="modal"
                        (click)="modalClick(false)">
                        Confirm Without Tracker
                      </button>
                      <button type="button" class="subBtnModalTrackerOn  custom-btn" data-bs-dismiss="modal"
                        (click)="modalClick(true)">
                        Enable Tracker & Confirm
                      </button>
                    </div>
                  </div>
                }
                @if (toggleUserStatus== 0) {
                  <div class="modal-body text-center" [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }"
                    >
                    <button type="button" class="btn-close float-end" data-bs-dismiss="modal" aria-label="Close"></button>
                    <img src="../../../assets/images/trackerQuestion.png" class="imageConfirmModal" alt="img loading...">
                    <p class="modal-text mt-3 ">
                      Are you sure you want to <span class="textColorQuestionMOdal">Change </span> <span
                      class="textColorMOdal">{{
                      userNameForModal
                    }}</span> status
                    to
                    <span class="textColorMOdal">work from home</span>?
                  </p>
                  <div class="buttonTrackers gap-3 mt-3 mb-3">
                    <button type="button" class="subBtnModalTrackerOff custom-btn" data-bs-dismiss="modal">
                      Cancel
                    </button>
                    <button type="button" class="subBtnModalTrackerOn  custom-btn" data-bs-dismiss="modal"
                      (click)="modalClickChangeValues()">
                      Confirm
                    </button>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
        <!-- en -->
      </div>
    }
    <!-- Ex employeee -->
    @if (isoldEmployee) {
      <div class=" mt-0">
        <div class="businessteam-section mt-4">
          @for (department of departmentNames1; track department) {
            <div class="businessteam-section mt-4">
              @if (oldUsersList[department] && oldUsersList[department].length > 0) {
                <div class="heading-main py-2"
                  [ngClass]="{ 'dark-text': selectedMode === 'dark' }">
                  <h1 class="">{{ department }}</h1>
                </div>
              }
              <div class="employee-grid management-row">
                @for (user of oldUsersList[department]; track user; let i = $index) {
                  <div class="employee-card teamlead-card my-2"
                    [style.background-image]="user.backgroundImage ? 'url(' + user.backgroundImage + ')' : ''">
                    <div class="div mb-3" (click)="showDetails(user)">
                      <div class="image-titles d-flex justify-content-between">
                        <div class="employee-year">
                          @if ( userRolesArray[departmentNames1.indexOf(department)][i] === 'Admin' ||  userRolesArray[departmentNames1.indexOf(department)][i] === 'Admin_AND_Team_Lead') {
                            <img src="../../../assets/images/admin.png" alt=""
                              >
                          }
                          <!-- <h1>1</h1> -->
                        </div>
                        <div class="employee-year">
                          @if ( userRolesArray[departmentNames1.indexOf(department)][i] === 'Team_Lead' ||  userRolesArray[departmentNames1.indexOf(department)][i] === 'Admin_AND_Team_Lead') {
                            <img src="../../../assets/images/team lead.png" alt=""
                              >
                          }
                        </div>
                      </div>
                      <div class="employee-profile text-center">
                        <div class="profile-image">
                          <img src="{{user.profile_image }}" alt="image">
                        </div>
                        <h1 class="mt-2 mb-1">{{user.first_name}} {{user.last_name}}</h1>
                        <h2>{{user.description}}</h2>
                        <!-- <h2>{{ userRolesArray[departmentNames.indexOf(department)][i] }}</h2> -->
                      </div>
                      <div class="employee-info mt-2">
                        <p><img src="../../../assets/images/mail.png" alt=""> {{user.email}}</p>
                        <p><img src="../../../assets/images/clock.png" alt="">
                          {{ convertTo12Hour(user.usershittime[0].start_time || user.shift_start_time) }}
                          to
                          {{ convertTo12Hour(user.usershittime[0].end_time || user.shift_end_time) }}
                        </p>
                        <div class="employee-eva">
                          <h1 class="pr-2">7</h1>
                          <p><span>EVALUATION</span><span>OUT</span><span>OF 10</span></p>
                        </div>
                        <div class="employee-info-footer">
                          <!-- <h3>Allow WFH for Today:</h3> -->
                          <!-- <input [checked]="user.attandance_type != 'Normal'" type="checkbox"
                          (click)="toggleClick(user.id, $event)"> -->
                        </div>
                      </div>
                    </div>
                    <!-- <div class="employee-card-footer text-center py-2">(click)="childClick($event)"
                    <a (click)="childClick($event)" *ngFor="let footerImage of getFooterImages(department)">
                      <img [src]="'../../../assets/images/' + footerImage" alt="">
                    </a>
                  </div> -->
                  <div class="col-12 d-flex justify-content-between mt-3 mb-3 flex-wrap">
                    @if (isavailablefeature('isDeleteUser') ) {
                      <button (click)="retrivedModal(user)"
                        class="retrived-btn text-center btn btn-light " type="submit" data-toggle="modal"
                        data-target="#retrivedModal">
                        <div><img src="../../../assets/images/refresh.png" alt="Missing image" class="activity-tracker"> Re
                        Active</div>
                      </button>
                    }
                  </div>
                  <!-- bottom-border  -->
                  <div class="yellow-label">
                  </div>
                  <div class="yellow-label-left">
                  </div>
                  <div class="yellow-label-right">
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }
  <!-- delete modal -->
  <div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
        <div class="modal-header" [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
          <h5 class="modal-title" id="exampleModalLongTitle">Confirmation</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
          <p>Are you sure you want to <b>Delete </b> this User?</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          <input type="hidden" [(ngModel)]="user.uuid">
          <button type="button" (click)="UserDelete()" class="btn btn-danger">Delete</button>
        </div>
      </div>
    </div>
  </div>
  <!-- delete modal -->
  <div class="modal fade" id="retrivedModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
        <div class="modal-header" [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
          <h5 class="modal-title" id="exampleModalLongTitle">Confirmation</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
          <p>Are you sure you want to <b>Active </b> this User again?</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          <input type="hidden" [(ngModel)]="user.uuid">
          <button type="button" (click)="UserRetrived()" class="btn btn-primary">Active</button>
        </div>
      </div>
    </div>
  </div>
  <!-- qick Edit Modal -->
  <div class="modal fade" id="quickEditModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog model-main modal-dialog-centered" role="document">
      <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
        <div class="modal-header modal-buttons-header"
          [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
          <img src="../../../assets/images/quick2.png">
          <h5 class="modal-title" id="exampleModalLabel">Quick Edit User Data</h5>
        </div>
        <div class="modal-body row">
          <div class="modal-btn mt-2 mb-2 col-6 text-center">
            <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#updateStatus"
              (click)="getUserdata(selectedUserUUID)" data-dismiss="modal">
            Status</button>
          </div>
          <div class="modal-btn mt-2 mb-2 col-6 text-center">
            <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#updatePassword"
              data-dismiss="modal">
            Password</button>
          </div>
          <!-- <div class="modal-btn mt-2 mb-2 col-6 text-center">
          <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#updateSifhtTime"
            (click)="getUserdata(selectedUserUUID)" data-dismiss="modal">
          Shift Time</button>
        </div> -->
        <div class="modal-btn mt-2 mb-2 col-6 text-center">
          <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#updateAccountNo"
            (click)="getUserdata(selectedUserUUID)" data-dismiss="modal">
          Bank Account</button>
        </div>
        <div class="modal-btn mt-2 mb-2 col-6 text-center">
          <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#updateSalary"
          (click)="getUserdata(selectedUserUUID)" data-dismiss="modal">User Salary</button>
        </div>
        <div class="modal-btn mt-2 mb-2 col-6 text-center">
          <button type="button" class="btn btn-primary" data-dismiss="modal"
          (click)="UserUpdate(selectedUserUUID)">Edit User</button>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
</div>
}


<!-- status Model -->

<!-- status update -->
<div class="modal fade hidecolor" id="updateStatus" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog model-main modal-dialog-centered" role="document">

    <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
      <form #statusUpdate="ngForm" (ngSubmit)="updateStatus(statusUpdate)">
        <div class="modal-btn modal-header modal-buttons-header"
          [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
          <img src="../../../assets/images/quick2.png">
          <h5 class="modal-title" id="updateStatusLabel">Edit User Status</h5>
        </div>
        <div class="modal-body d-flex flex-wrap justify-content-center">
          <div class="col-8 mt-2 mb-2 select-box" [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
            <select id="employee_type" [ngModel]="(apidata != null) ? apidata.employee_type : null"
              name="employee_type" data-toggle="dropdown"
              class="dropdown-toggle checks-dropdown form-control pl-4 selectpicker" ngModel #employee_type="ngModel"
              required>
              <option value="null" disabled selected>Select Employee Status</option>
              @for (status of statuses; track status) {
                <option [value]="status">{{ status }} </option>
              }
            </select>

          </div>

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
          <button type="submit" class="btn btn-success">Save changes</button>
        </div>
      </form>
    </div>


  </div>
</div>





<!-- password Model -->
<div class="modal fade hidecolor" id="updatePassword" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog model-main modal-dialog-centered " role="document">
    <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
      <form #passwordUpdate="ngForm" (ngSubmit)="updatePassword(passwordUpdate)">
        <div class="modal-btn modal-header modal-buttons-header"
          [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
          <img src="../../../assets/images/quick2.png">
          <h5 class="modal-title" id="updatePasswordLabel">Edit User Password</h5>
        </div>

        <div class="modal-body d-flex flex-wrap justify-content-center">
          <div class="col-8 mt-2 mb-2 select-box">
            <input type="text" inputmode="none" name="password" id="password" placeholder="Enter New Password"
              class="form-control" ngModel required />
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
            <button type="submit" class="btn btn-success">Save changes</button>
          </div>
        </form>

      </div>
    </div>
  </div>




  <!-- shifttime Model -->
  <div class="modal fade hidecolor" id="updateSifhtTime" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog model-main modal-dialog-centered " role="document">
      <div class="modal-content " [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
        <form #ShiftTimeUpdate="ngForm" (ngSubmit)="updateShiftTime(ShiftTimeUpdate)">
          <div class="modal-btn modal-header modal-buttons-header"
            [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
            <img src="../../../assets/images/quick2.png">
            <h5 class="modal-title" id="updateSifhtTimeLabel">Edit Shift Time</h5>
          </div>
          <div class="modal-body d-flex flex-wrap justify-content-center">
            <div class="col-8 mt-2 mb-2 select-box">
              <input type="time" [ngModel]="(apidata != null) ? apidata.shift_start_time : null"
                onfocus="(this.type='time')" onblur="(this.type= this.value ? 'time' : 'text')" name="startTime"
                id="startTime" ngModel #startTime="ngModel" class="form-control date-type " required />
              </div>
              <div class="col-8">
                <input type="text" [ngModel]="(apidata != null) ? apidata.shift_end_time : null"
                  placeholder="Enter Shift End Time" onfocus="(this.type='time')"
                  onblur="(this.type= this.value ? 'time' : 'text')" name="endTime" id="endTime" ngModel
                  #startTime="ngModel" class="form-control date-type " required />
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
                <button type="submit" class="btn btn-success">Save changes</button>
              </div>
            </form>
          </div>
        </div>
      </div>


      <!-- Account No update -->
      <div class="modal fade hidecolor" id="updateAccountNo" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog model-main modal-dialog-centered " role="document">
          <div class="modal-content " [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            <form #accountUpdate="ngForm" (ngSubmit)="updateAccount(accountUpdate)">
              <div class="modal-btn modal-header modal-buttons-header"
                [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
                <img src="../../../assets/images/quick2.png">
                <h5 class="modal-title" id="updateAccountNo">Edit Account No</h5>
              </div>
              <div class="modal-body d-flex flex-wrap justify-content-center">
                <div class="col-8 mt-2 mb-2 select-box">
                  <input type="text" name="ac_number" [ngModel]="(apidata != null) ? apidata.ac_number : null"
                    (input)="restrictInputToAccounts($event)" id="ac_number" placeholder="Meezan Bank Account#*"
                    class="form-control no-spin-arrows" ngModel #ac_number="ngModel" required />
                    @if (ac_number.touched && ac_number.invalid ) {
                      <div class="text-danger pl-3 mt-2">
                        i.e. 0000-0000000000
                      </div>
                    }
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
                  <button type="submit" class="btn btn-success">Save changes</button>
                </div>
              </form>
            </div>
          </div>
        </div>



        <!-- Salary update -->
        <div class="modal fade hidecolor" id="updateSalary" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog model-main modal-dialog-centered " role="document">
            <div class="modal-content " [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
              <form #salaryUpdate="ngForm" (ngSubmit)="updateSalary(salaryUpdate)">
                <div class="modal-btn modal-header modal-buttons-header"
                  [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
                  <img src="../../../assets/images/quick2.png">
                  <h5 class="modal-title" id="updateSalarylabel">Edit User Salary</h5>
                </div>
                <div class="modal-body d-flex flex-wrap justify-content-center">
                  <div class="col-8 mt-2 mb-2 select-box" [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
                    <input type="text" name="salary" [ngModel]="(apidata != null) ? apidata.basic_salary : null" id="salary"
                      placeholder="Monthly Salary*" class="form-control pl-4" ngModel #salary="ngModel" readonly />
                    </div>
                    <div class="col-8 mt-2 mb-2 select-box">
                      <input type="text" name="newSalary" id="newSalary" placeholder="Enter New Salary Here*"
                        class="form-control pl-4" ngModel #salary="ngModel" />
                      </div>
                      <div class="col-8 mt-2 mb-2 select-box">
                        <input type="text" name="salaryTax" id="salaryTax" placeholder="Enter Salary Tax Here*"
                          class="form-control pl-4" ngModel #salaryTax="ngModel" />
                        </div>
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
                        <button type="submit" class="btn btn-success">Save changes</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>






            </main>